import { WTextfield } from '@alice-health/wonderland-react'
import { FunctionComponent } from 'react'
import { useFormContext } from 'react-hook-form'

interface PhoneFieldProps {
  placeholder?: string
}

const PhoneField: FunctionComponent<PhoneFieldProps> = ({
  placeholder = 'Telefone de contato'
}) => {
  const {
    register,
    setValue,
    clearErrors,
    trigger,
    formState: { errors }
  } = useFormContext<{
    telefone: string
  }>()

  return (
    <>
      {/* Phone Name field cannot be changed because of Google Ads Conversion */}
      <WTextfield
        {...register('telefone')}
        placeholder={placeholder}
        maskType='cel'
        invalid={!!errors.telefone}
        errorText={errors.telefone?.message}
        onWChange={ev => setValue('telefone', ev.detail)}
        onInput={() => clearErrors('telefone')}
        onBlur={() => trigger('telefone')}
      />
    </>
  )
}

export { PhoneField }
